module.exports = __webpack_public_path__ + "static/media/365GradientHeader.00ecc71d.png";